<template>
  <v-app>
    <NavBar v-if="user !== null"></NavBar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>

import NavBar from "./views/NavBar";
export default {
  name: 'App',
    data () {
      return {
      }
  },
  components: {
      NavBar
  },
  computed: {
    user(){
      return this.$store.getters.getUser;
    },
      userData(){
          return this.$store.getters.getUserData;
      },
  },
  methods: {
  },
  created () {
    if (this.user === null) {
      this.$store.dispatch('firstUserSet').then(() => {
        console.log('initialization');
      })
    }
  }
};
</script>

<style lang="css">
  @import './style/BaseStyle.css';
</style>

